import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = { class: "dropdown d-inline" }
const _hoisted_5 = {
  class: "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
  role: "menu"
}
const _hoisted_6 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-revenue"
}
const _hoisted_7 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-margin-cogs"
}
const _hoisted_8 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-resource"
}
const _hoisted_9 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-resource-cost"
}
const _hoisted_10 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-total-cost"
}
const _hoisted_11 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-expense"
}
const _hoisted_12 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-cost-subtotal"
}
const _hoisted_13 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-opex"
}
const _hoisted_14 = {
  class: "dropdown-item",
  "data-testid": "metrics-page-create-capex"
}
const _hoisted_15 = {
  key: 0,
  class: "d-flex flex-wrap mb-3"
}
const _hoisted_16 = { style: {"width":"250px"} }
const _hoisted_17 = { class: "dropdown ml-3" }
const _hoisted_18 = { class: "dropdown-menu dropdown-menu-right dropdown-menu-scrollable" }
const _hoisted_19 = ["onClick", "data-testid"]
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = {
  class: "table table-bordered table-hover",
  "data-testid": "metrics-page-table"
}
const _hoisted_22 = ["data-testid"]
const _hoisted_23 = ["data-testid"]
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = ["data-testid"]
const _hoisted_27 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_28 = ["data-testid"]
const _hoisted_29 = ["data-testid"]
const _hoisted_30 = ["onClick", "data-testid"]

import { computed, onMounted, ref, watch, type Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import { useMetricsPageQueryV1 } from '@Quest/Metrics/queries-vue-composables'
    import { useDeleteMetricCommandV1 } from '@Quest/Metrics/commands-vue-composables'
    import type { MetricReadModel, MetricsPageReadModel } from '@Quest/Metrics/readmodels'
    import { ValidationError } from '@common/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MetricsPage',
  setup(__props) {

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const {
        runMetricsPageQueryV1,
        modelMetricsPageQueryV1
    } = useMetricsPageQueryV1(workspaceId, strategyId)

    const rm = modelMetricsPageQueryV1 as Ref<MetricsPageReadModel | null>

    const {
        invokeDeleteMetricCommandV1,
        onSucceedDeleteMetricCommandV1,
        validationErrorsDeleteMetricCommandV1
    } = useDeleteMetricCommandV1(workspaceId, strategyId)

    const searchPhrase = ref<string | null>(null)
    const filterByMetricType = ref<string | null>(null)

    const metricsView = computed<MetricReadModel[]>(() =>
    {
        if (!rm.value || !rm.value.Metrics) return []

        const phrase = searchPhrase.value?.toLowerCase()
        const typeFilter = filterByMetricType.value

        return rm.value.Metrics.filter(a =>
            (!phrase || a.Name.toLowerCase().includes(phrase)) &&
            (!typeFilter || a.MetricTypeLabel === typeFilter)
        )
    })

    function setFilterByMetricType(metricType: string | null)
    {
        filterByMetricType.value = metricType
    }

    function getEditUrl(m: MetricReadModel): string
    {
        switch (m.MetricType)
        {
            case 'CostSubtotalMetric':
                return `/#/enterprise/edit-cost-subtotal-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'ResourceMetric':
                return `/#/enterprise/edit-resource-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'ResourceCostMetric':
                return `/#/enterprise/edit-resource-cost-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'RevenueMetric':
                return `/#/enterprise/edit-revenue-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'MarginCogsMetric':
                return `/#/enterprise/edit-margin-cogs-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'TotalCostMetric':
                return `/#/enterprise/edit-total-cost-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'CapexMetric':
                return `/#/enterprise/edit-capex-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'ExpenseMetric':
                return `/#/enterprise/edit-expense-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'OpexMetric':
                return `/#/enterprise/edit-opex-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            default:
                return ''
        }
    }

    function getCloneUrl(m: MetricReadModel): string
    {
        switch (m.MetricType)
        {
            case 'CostSubtotalMetric':
                return `/#/enterprise/clone-cost-subtotal-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'ResourceMetric':
                return `/#/enterprise/clone-resource-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'ResourceCostMetric':
                return `/#/enterprise/clone-resource-cost-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'RevenueMetric':
                return `/#/enterprise/clone-revenue-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'MarginCogsMetric':
                return `/#/enterprise/clone-margin-cogs-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'TotalCostMetric':
                return `/#/enterprise/clone-total-cost-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'CapexMetric':
                return `/#/enterprise/clone-capex-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'ExpenseMetric':
                return `/#/enterprise/clone-expense-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            case 'OpexMetric':
                return `/#/enterprise/clone-opex-metric/${workspaceId.value}/${strategyId.value}/${m.Id}`
            default:
                return ''
        }
    }

    function handleDeleteMetricCommand(id: string)
    {
        if (confirm("Are you sure?") === true)
        {
            invokeDeleteMetricCommandV1({ Id: id })
        }
    }

    onMounted(() =>
    {
        document.title = "Metrics | TransparentChoice"
        runMetricsPageQueryV1()
    })

    onSucceedDeleteMetricCommandV1(() =>
    {
        runMetricsPageQueryV1()
    })

    watch(validationErrorsDeleteMetricCommandV1, (errors: ValidationError[] | null) =>
    {
        if (!errors || errors.length === 0) return

        const error = errors[0]
        alert(error.Error)
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "metrics" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Metrics")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[13] || (_cache[13] = _createElementVNode("button", {
                  class: "btn btn-outline-secondary dropdown-toggle",
                  "data-toggle": "dropdown",
                  style: {"padding":"0.7em 2em"},
                  "data-testid": "metrics-page-create-button"
                }, " Create metric ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Revenue", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-revenue-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("COGS (Margin)", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-margin-cogs-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Resource (units)", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-resource-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Resource (money)", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-resource-cost-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Total cost", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-total-cost-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Expense", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-expense-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Cost subtotal", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-cost-subtotal-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Opex", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-opex-metric/${workspaceId.value}/${strategyId.value}`]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Capex", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, `/#/enterprise/create-capex-metric/${workspaceId.value}/${strategyId.value}`]
                  ])
                ])
              ])
            ])
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          (_unref(rm))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createCommentVNode(" Search Field  "),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "search",
                    class: "form-control",
                    placeholder: "Search by name...",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event)),
                    "data-testid": "metrics-page-search"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, searchPhrase.value]
                  ])
                ]),
                _createCommentVNode(" Type Filter Dropdown (Left Side) "),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn", filterByMetricType.value ? 'btn-info' : 'btn-outline-secondary']),
                    type: "button",
                    "data-toggle": "dropdown",
                    "data-testid": "metrics-page-filter-button"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-filter mr-1", filterByMetricType.value ? 'text-warning' : 'text-muted'])
                    }, null, 2 /* CLASS */),
                    _cache[15] || (_cache[15] = _createElementVNode("span", null, "Metric type", -1 /* CACHED */))
                  ], 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["dropdown-item", { 'active': filterByMetricType.value === null }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setFilterByMetricType(null))),
                      "data-testid": "metrics-page-filter-any"
                    }, " Any / No filter ", 2 /* CLASS */),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by metric type", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).MetricTypes, (m, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: _normalizeClass(["dropdown-item", { 'active': filterByMetricType.value === m }]),
                        key: m,
                        onClick: ($event: any) => (setFilterByMetricType(m)),
                        "data-testid": `metrics-page-filter-${index}`
                      }, _toDisplayString(m), 11 /* TEXT, CLASS, PROPS */, _hoisted_19))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Metric"),
                  _createElementVNode("th", null, "Type"),
                  _createElementVNode("th", { style: {"width":"120px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metricsView.value, (m, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: m.Id,
                    "data-testid": `metrics-page-row-${index}`
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", {
                        class: "text-primary",
                        "data-testid": `metrics-page-edit-link-${index}`
                      }, [
                        _createTextVNode(_toDisplayString(m.Name), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_23)), [
                        [_directive_sanitizedHref, getEditUrl(m)]
                      ]),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(m.Description), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(m.MetricTypeLabel), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown",
                          "data-testid": `metrics-page-actions-button-${index}`
                        }, " Actions ", 8 /* PROPS */, _hoisted_26),
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            class: "dropdown-item",
                            "data-testid": `metrics-page-actions-edit-${index}`
                          }, [...(_cache[18] || (_cache[18] = [
                            _createTextVNode("Edit", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_28)), [
                            [_directive_sanitizedHref, getEditUrl(m)]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            class: "dropdown-item",
                            "data-testid": `metrics-page-actions-clone-${index}`
                          }, [...(_cache[19] || (_cache[19] = [
                            _createTextVNode("Clone", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_29)), [
                            [_directive_sanitizedHref, getCloneUrl(m)]
                          ]),
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (handleDeleteMetricCommand(m.Id)),
                            "data-testid": `metrics-page-actions-delete-${index}`
                          }, "Delete", 8 /* PROPS */, _hoisted_30)
                        ])
                      ])
                    ])
                  ], 8 /* PROPS */, _hoisted_22))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})